import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Calendar, Package } from 'lucide-react';
import { products } from '../data/mockData';

export const Products = () => {
  return (
    <section id="productos" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Productos
          </h2>
          <div className="w-24 h-1 bg-[#019645] mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hortalizas frescas de primera calidad con disponibilidad consistente para su negocio
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <Card
              key={product.id}
              className="overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-3 group"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 text-3xl font-bold text-white">
                  {product.name}
                </h3>
              </div>
              <CardContent className="p-6 bg-gradient-to-b from-gray-50 to-white">
                <div className="mb-4">
                  <Badge className="bg-[#019645] text-white hover:bg-[#077c38] mb-2">
                    {product.variety}
                  </Badge>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <Package className="w-5 h-5 text-[#019645] mr-2 mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-semibold text-gray-700">Presentación:</p>
                      <p className="text-gray-600">{product.presentation}</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <Calendar className="w-5 h-5 text-[#019645] mr-2 mt-1 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-semibold text-gray-700">Disponibilidad:</p>
                      <p className="text-gray-600">{product.availability}</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl p-8 border-l-4 border-[#019645]">
          <p className="text-gray-700 text-center text-lg">
            <strong className="text-[#019645]">Nota:</strong> Los volúmenes semanales varían de acuerdo a la época del año y contratos vigentes. 
            Contáctenos para conocer disponibilidad actual y precios especiales por volumen.
          </p>
        </div>
      </div>
    </section>
  );
};
